export default __webpack_public_path__ + "static/media/img16.f1af8b12.jfif";